/**
===================================================
Module: frontend.src.components.TopBar.tsx
Description: Top navigation bar component
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/

import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import "../styles/TopBar.css";

interface TopBarProps {
  showLogo?: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ showLogo = true }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const { user, logout } = useAuth();
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        {showLogo && (
          <div className="logo">
            <img src="/logo.png" alt="KTS Logo" className="logo-image" />
          </div>
        )}
      </div>

      <div className="topbar-right">
        <div className="user-menu" ref={dropdownRef}>
          <div
            className="user-avatar"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            {user?.username?.charAt(0).toUpperCase() || "U"}
          </div>

          {showDropdown && (
            <div className="dropdown-menu">
              <div className="dropdown-header">
                <div className="user-avatar-dropdown">
                  {user?.username?.charAt(0).toUpperCase() || "U"}
                </div>
                <div className="user-info">
                  <div className="user-name">{user?.full_name || "User"}</div>
                  <div className="user-email">
                    {user?.email || "user@example.com"}
                  </div>
                </div>
              </div>
              <button
                className="dropdown-item logout-btn"
                onClick={handleLogout}
              >
                ログアウト
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
